export default __webpack_public_path__ + "static/viaduct-76219102958a74f493a779c8269eff87.png";